<template>
  <div class="driver-table-container col-12">
    <b-alert :show="error && error.length ? true : false" variant="danger">
      <div v-if="Array.isArray(error)">
        <div class="d-flex flex-column my-1" v-for="(error_text, index) in error" :key="index">
          {{ error_text }}
        </div>
      </div>
      <div v-else>
        <div v-html="error || '&nbsp;'"></div>
      </div>
    </b-alert>
    <div>
      <div class="trip-panel d-flex justify-content-between align-items-center" v-if="isReassign">
        <div class="trip-panel__text d-flex justify-content-center align-items-center">
          <div class="img-container d-flex justify-content-center align-items-center">
            <img src="@/assets/images/icons/information-circle-blue.svg" alt="info-circle" />
          </div>
          <div class="flex-col">
            <p class="title mb-1">{{ $t("important-notice") }}</p>
            <span>{{ $t("reassign-hint") }}</span>
          </div>
        </div>
      </div>
      <div class="p-0 my-1 d-flex align-items-center mx-1">
        <div class="col-3 mx-1">
          <base-select class="searchOption bg-transparent mb-0" id="change-driver-searchOption" :options="searchOptions"
            :value="searchObj.searchOption" @change-value="changeSearchOption" :useI18n="true">
          </base-select>
        </div>
        <div class="col-4 mx-1" v-if="searchObj.searchOption === 'nationality'">
          <base-select class="searchOption bg-transparent mb-0" id="change-driver-nationality"
            :disabled="!showNationality" :options="$store.getters['enums/drivers_available_nationality_enums']
              " :value="selectedNationality" @change-value="changeNationality">
          </base-select>
        </div>
        <div class="col-4 mx-1" v-if="searchObj.searchOption !== 'nationality'">
          <base-input type="text" id="change-driver-searchText" class="mb-0" name="Name" placeholder="keywords-here"
            field="searchText" :small="true" :value="searchObj.searchText"
            @change-value="(val) => searchObj.searchText = val"></base-input>
        </div>
        <div class="d-flex">
          <div class="mx-1">
            <base-button class="primary search-btn mx-1" id="change-driver-search-btn" type="submit" :disabled="(!searchObj.searchOption || !searchObj.searchText) &&
              (!searchObj.searchOption || !selectedNationality)
              " @click="handledRequest">
              {{ $t("search") }}
            </base-button>
          </div>
          <div class="mx-1">
            <base-button variant="secondary" id="change-driver-reset-btn" :disabled="!searchObj.searchOption && (!searchObj.searchOption || !selectedNationality)
              " @click="reset">
              {{ $t("reset") }}
            </base-button>
          </div>
        </div>
      </div>
    </div>
    <base-spinner v-if="loading" />

    <div v-else class="col-12 mt-4">
      <b-table :items="items" :fields="fields" :hover="true" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
        :per-page="0" :current-page="currentPage" show-empty label-sort-asc="" label-sort-desc="" label-sort-clear=""
        sort-icon-right :no-border-collapse="true" responsive="xl" thead-class="table-thead text-center bg-transparent "
        tbody-class="table-tbody text-center " ref="selectableTable" info="true" class="new-theme-custom-table">
        <template #head(id)="data">
          <span v-if="data">#</span>
        </template>

        <template #cell(id)="{ item }">
          <div class="d-flex align-items-center ps-3">
            <div>
              <input type="checkbox" @change="toggleSelect(item)" :checked="selectedDriverId === item.driverId"
                :value="item.driverId" :disabled="disableSelect(item.driverId)" class="cursor-pointer mx-3" />
            </div>
            <div v-if="item.employeeID">{{ item.employeeID }}</div>
          </div>
        </template>
        <template #cell(languages)="{ item }">
          <div class="d-flex justify-content-evenly">
            <div v-if="item.languages">
              {{
                isLangRtl
                  ? item.languages?.map((obj) => obj.arabicName).join(", ")
                  : item.languages?.map((obj) => obj.name).join(", ")
              }}
            </div>
          </div>
        </template>

        <template #cell(nationality)="{ item }">
          <div class="d-flex justify-content-evenly">
            <div v-if="item.nationality">
              {{ item.nationality.join(", ") }}
            </div>
          </div>
        </template>

        <template #cell(source)="{ item }">
          <div class="d-flex justify-content-evenly">
            <div v-if="item.img">
              <img :src="require(`@/assets/images/${item.img}.svg`)" />
            </div>
            <div>{{ item.source }}</div>
          </div>
        </template>
      </b-table>
      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" first-number last-number
        aria-controls="my-table" class="d-flex justify-content-end"></b-pagination>
    </div>
  </div>
</template>

<script>
import TripService from "@/services/trip.service";
import DriverService from "@/services/driver.service";

export default {
  name: "DriverList",
  emits: ["selectDriver"],
  props: ["trip", "selectedDriverId", "selectedVehicleId", "isMainDriver", "isReassign"],
  data() {
    return {
      error: null,
      loading: false,
      sortDesc: false,
      selectedNationality: null,
      showNationality: false,
      perPage: 20,
      currentPage: 1,
      modes: ["single", "range"],
      fields: [
        {
          key: "id",
          label: "#",
          sortable: false,
          class: "align-middle",
        },
        {
          key: "name",
          label: this.$t("name-in-english"),
          sortable: false,
          class: "px-1 align-middle",
        },
        {
          key: "arabicName",
          label: this.$t("name-in-arabic"),
          sortable: false,
          class: "px-1 align-middle",
        },
        {
          key: "mobileNumber",
          label: this.$t("phone-number"),
          class: "align-middle",
          sortable: true,
        },
        {
          key: "nationality",
          label: this.$t("nationality"),
          sortable: false,
          class: "align-middle",
        },
        {
          key: "languages",
          label: this.$t("language"),
          sortable: false,
          class: "align-middle",
        },
      ],
      items: [],
      rows: 0,
      sortBy: "",
      sortOrders: {},
      searchText: "",
      searchOptions: [
        { value: null, text: "search-for" },
        {
          value: "employeeID",
          text: "employee-id",
        },
        {
          value: "name",
          text: "name-in-english",
        },
        {
          value: "arabicName",
          text: "name-in-arabic",
        },
        {
          value: "mobileNumber",
          text: "phone-number",
        },
        {
          value: "nationality",
          text: "nationality",
        },
      ],
      searchObj: {
        searchOption: "employeeID",
        searchText: "",
      },
      nationalities: [],
    };
  },
  computed: {
    disableSelect() {
      return (driverId) => {
        return this.selectedDriver && this.selectedDriver !== driverId;
      };
    }
  },
  watch: {
    currentPage() {
      this.handledRequest();
    },
    selectedDriverId(newDriverId) {
      if (newDriverId) {
        this.disableAllCheckboxesExcept(newDriverId);
      } else {
        this.enableAllCheckboxes();
      }
    },
  },
  methods: {
    handledRequest() {
      if (this.trip?.status === 'Trip-Completed' || this.trip?.status === 'Trip-Completed-Note') {
        this.searchForReassignDrivers();
      } else {
        this.searchForDrivers();
      }
    },
    disableAllCheckboxesExcept(driverId) {
      if (this.items && this.items?.length) {
        this.items.slice().forEach((driver) => {
          if (driver.driverId !== driverId) {
            driver.disabled = true;
          }
        });
      }
    },
    enableAllCheckboxes() {
      if (this.items && this.items?.length) {
        this.items.slice().forEach((driver) => {
          driver.disabled = false;
        });
      }
    },
    AssignDriverToDriver() {
      this.$router.push("/driver/assign-driver").catch(() => { });
    },
    async searchForDrivers() {
      this.$emit("selectDriver", null);
      this.loading = true;
      let params = new URLSearchParams();
      params.append("page", this.currentPage || 1);
      params.append("limit", this.perPage);
      params.append("sort", "-updated_on");

      if (this.searchObj?.searchText.length) {
        if (this.searchObj?.searchOption === "name") {
          params.append("name", "*" + this.searchObj.searchText + "*");
        }

        if (this.searchObj?.searchOption === "arabicName") {
          params.append("arabicName", "*" + this.searchObj.searchText + "*");
        }

        if (this.searchObj?.searchOption === "mobileNumber") {
          params.append("mobileNumber", "*" + this.searchObj.searchText + "*");
        }

        if (this.searchObj?.searchOption === "employeeID") {
          params.append("employeeID", "*" + this.searchObj.searchText + "*");
        }
      }

      if (
        this.selectedNationality &&
        this.searchObj.searchOption == "nationality"
      ) {
        params.append("nationality", this.selectedNationality);
      }

      const body = {
        id: this.trip?._id,
      };

      if (this.isMainDriver && this.selectedVehicleId) {
        body.vehicle = this.selectedVehicleId;
      }

      TripService.post(body, "available-drivers-paginated", params)
        .then((res) => {
          const { items = [], total = 0 } = res || {};

          this.items = items.map((each) => ({
            driverId: each?._id,
            id: each?._id,
            name: each?.name,
            arabicName: each?.arabicName,
            mobileNumber: each?.mobileNumber,
            nationality: each?.nationality,
            languages: each?.languages,
            idNumber: each?.idNumber,
            licenseType: each?.licenseType,
            vehicle: each?.vehicle || null,
            employeeID: each?.employeeID,
            religion: each?.religion,
            profilePicture: each?.profilePicture,
          }));

          this.rows = total;
        })
        .catch((error) => {
          this.error = error.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async searchForReassignDrivers() {
      this.$emit("selectDriver", null);
      this.loading = true;
      let params = new URLSearchParams();
      params.append("page", this.currentPage || 1);
      params.append("limit", this.perPage);
      params.append("sort", "-updated_on");

      if (this.searchObj?.searchText.length) {
        if (this.searchObj?.searchOption === "name") {
          params.append("name", "*" + this.searchObj.searchText + "*");
        }

        if (this.searchObj?.searchOption === "arabicName") {
          params.append("arabicName", "*" + this.searchObj.searchText + "*");
        }

        if (this.searchObj?.searchOption === "mobileNumber") {
          params.append("mobileNumber", "*" + this.searchObj.searchText + "*");
        }

        if (this.searchObj?.searchOption === "employeeID") {
          params.append("employeeID", "*" + this.searchObj.searchText + "*");
        }
      }

      if (
        this.selectedNationality &&
        this.searchObj.searchOption == "nationality"
      ) {
        params.append("nationality", this.selectedNationality);
      }

      const body = {
        id: this.trip?._id,
      };

      if (this.isMainDriver && this.selectedVehicleId) {
        body.vehicle = this.selectedVehicleId;
      }
      DriverService.get(`branch/${this.trip?.branch?._id}/trip/${this.trip._id}`, params)
        .then((res) => {
          const { items = [], total = 0 } = res || {};

          this.items = items.map((each) => ({
            driverId: each?._id,
            id: each?._id,
            name: each?.name,
            arabicName: each?.arabicName,
            mobileNumber: each?.mobileNumber,
            nationality: each?.nationality,
            languages: each?.languages,
            idNumber: each?.idNumber,
            licenseType: each?.licenseType,
            vehicle: each?.vehicle || null,
            employeeID: each?.employeeID,
            religion: each?.religion,
            profilePicture: each?.profilePicture,
          }));

          this.rows = total;
        })
        .catch((error) => {
          this.error = error.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeNationality(val) {
      this.selectedNationality = val;
    },
    changeSearchOption(option) {
      if (option == "nationality") {
        this.showNationality = true;
        this.searchObj.searchOption = option;
        this.searchObj.searchText = "";
      } else {
        this.showNationality = false;
        this.selectedNationality = null;
        this.searchObj.searchOption = option;
      }
    },
    reset() {
      this.searchObj.searchOption = null;
      this.showNationality = false;
      this.searchObj.searchText = "";
      this.selectedNationality = null;
      this.currentPage = 1;
      this.handledRequest();
    },
    toggleSelect(item) {
      if (item.driverId === this.selectedDriverId) {
        this.$emit("selectDriver", null);
      } else {
        this.$emit("selectDriver", item);
      }
    },
  },
  mounted() {
    this.handledRequest();
  },
  created() {
    this.$store.dispatch("enums/GET_DRIVERS_AVAILABLE_NATIONALITY_ENUMS");
  },
};
</script>
<style lang="scss" scoped>
.trip-panel {
  margin-bottom: 16px;
  padding: 10px;
  border-radius: 8px;
  background: var(--color-135);

  &__text {
    gap: 8px;

    .title {
      color: var(--color-13);
      margin: 0;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.25px;
      line-height: 20px;
      padding: 0
    }

    span {
      color: var(--color-115);
      font-size: 15px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: 0.25px;
    }
  }

  .img-container {
    height: 30px;
    width: 30px;
    background-color: var(--color-140);
    border-radius: 50%;
  }
}
</style>
<style lang="scss">
.driver-table-container {
  input[type="checkbox"] {
    border-color: var(--color-23);
  }

  .multiselect .multiselect__tags {
    height: 40px;
    overflow: hidden;
  }

  .nationality_list {
    width: 207px !important;
  }
}

.change-driver {
  .b-sidebar {
    height: 83vh !important;
  }
}
</style>
